import React from "react";
import { Modal } from "antd";

import "./index.css";

const getPopupWidth = () => {
  if (window.innerWidth < 460) {
    return true;
  }
  return false;
};

export default function Popup({
  title = "Add Category",
  visible = false,
  width = "45%",
  cancelHandler,
  saveHandler,
  saveText = "Save",
  preSaveCheck,
  confirmBeforeSave = true,
  confirmTitle = "Confirm Save",
  confirmContent = "Do you want to save it?",
  confirmOkText = "Yes, Save",
  confirmCancelText = "Cancel",
  loading = false,
  children,
}) {
  const onConfirmSave = async () => {
    if (typeof preSaveCheck === "function") {
      try {
        const canProceed = await preSaveCheck();
        if (!canProceed) return;
      } catch (e) {
        return;
      }
    }

    if (!confirmBeforeSave) {
      saveHandler();
      return;
    }

    Modal.confirm({
      title: confirmTitle,
      content: confirmContent,
      okText: confirmOkText,
      cancelText: confirmCancelText,
      centered: true,
      onOk: () => saveHandler(),
    });
  };

  return (
    <div>
      <Modal
        confirmLoading={loading}
        bodyStyle={{ maxHeight: "68vh", overflowY: "auto" }}
        maskClosable={false}
        title={title}
        width={getPopupWidth() ? "85%" : width}
        centered
        visible={visible}
        okText={saveText}
        cancelButtonProps={{ size: "large" }}
        okButtonProps={{ size: "large" }}
        onOk={onConfirmSave}
        onCancel={() => cancelHandler()}
      >
        {children}
      </Modal>
    </div>
  );
}
